/**
 * Google reCAPTCHA v3 implementation for Nette Forms
 */
(function(document, window) {
    'use strict';

    // Initialize when page loads
    window.addEventListener('load', function() {
        const forms = document.querySelectorAll<HTMLFormElement>('form[data-recaptcha-v3]');

        forms.forEach(function(form) {
            const siteKey = form.getAttribute('data-recaptcha-v3');
            const tokenInput = form.querySelector<HTMLInputElement>('input[name="recaptcha_token"]');

            if (!siteKey || !tokenInput) {
                console.error('reCAPTCHA v3: Missing site key or token input field');
                return;
            }

            // Track if we're already processing
            let isProcessing = false;

            // Add event listener for form submission
            form.addEventListener('submit', function(e) {
                // If token already exists and is recent (< 90 seconds), allow submission
                if (tokenInput.value && tokenInput.dataset.timestamp) {
                    const age = Date.now() - parseInt(tokenInput.dataset.timestamp, 10);
                    if (age < 90000) { // 90 seconds
                        return true;
                    }
                }

                // Prevent double submission
                if (isProcessing) {
                    e.preventDefault();
                    return false;
                }

                // Prevent default submission
                e.preventDefault();
                e.stopPropagation();
                isProcessing = true;

                // Execute reCAPTCHA
                grecaptcha.ready(function() {
                    try {
                        grecaptcha.execute(siteKey, {action: 'contact_form'}).then(function(token) {
                            // Set token and timestamp
                            tokenInput.value = token;
                            tokenInput.dataset.timestamp = Date.now().toString();
    
                            // Reset processing flag
                            isProcessing = false;
    
                            // Submit form programmatically
                            form.submit();
                        });
                    } catch (error) {
                        console.error('reCAPTCHA v3 error:', error);
                        alert('Ověření reCAPTCHA selhalo. Zkuste to prosím znovu.');
                        isProcessing = false;
                    }
                });

                return false;
            });
        });
    });

})(document, window);

